








import { Vue, Component } from "vue-property-decorator";
import fetch from "@/common/api/fetch";
import getUrlParam from '@/common/utils/getUrlParam';
import { AxiosPromiseError } from "@/common/interface";

@Component
export default class Referrer extends Vue {
  referrerName: string = "";
  referrerAvatar: string = "";

  spead: boolean = true;

  mounted() {
    this.getReferInfo();
  }

  getReferInfo() {
    const promoterId = getUrlParam("promoterId");
    const param = {
      promoterId
    };
    fetch
      .post("c/xm/show/getMainById", param)
      .then((res: AxiosPromiseError) => {
        this.referrerAvatar = res.data.avatar;
        this.referrerName = res.data.nickname;
      });
  }

  handleSwitchSpead() {
    this.spead = !this.spead;
  }
}
